import React from 'react'
import App from 'App'
import { BrowserRouter } from 'libs/router'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'libs/query'
import axios from 'axios'
import './index.css'
import { CacheBuster } from '@piplup/cache-buster'

import {
	AuthContextProvider,
	NavContextProvider,
	StoreSettingsContextProvider,
	DashboardContextProvider
} from 'store'

if (process.env.REACT_APP_API_URL) {
	axios.defaults.baseURL = process.env.REACT_APP_API_URL
} else if (
	window?.location?.host === 'localhost:3000' ||
	window?.location?.host === 'assets-qa.smartgo.is'
) {
	axios.defaults.baseURL = 'https://superstore.smartgo-testing.splitti.is/api/v2'
} else {
	axios.defaults.baseURL = `https://${window.location.host}/api/v2`
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false
		}
	}
})

const container = document.getElementById('root')!
const root = createRoot(container)
root.render(
	<React.StrictMode>
		<CacheBuster />
		<AuthContextProvider>
			<QueryClientProvider client={queryClient}>
				<NavContextProvider>
					<StoreSettingsContextProvider>
						<DashboardContextProvider>
							<BrowserRouter>
								<App />
							</BrowserRouter>
						</DashboardContextProvider>
					</StoreSettingsContextProvider>
				</NavContextProvider>
			</QueryClientProvider>
		</AuthContextProvider>
	</React.StrictMode>
)
